export const sidebarData = [
  { id: 0, text: 'MANIFESTO', path: 'manifest', offset: -150 },
  { id: 1, text: 'NOSSOS SERVIÇOS', path: 'sectors', offset: -200 },
]